
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPlottedPositionIec as ObiPlottedPositionIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-plotted-position-iec.js';
 
 
 

 
 export const ObiPlottedPositionIec = createComponent({
   react: React,
   tagName: 'obi-plotted-position-iec',
   elementClass: ObiPlottedPositionIecElement,
   events: {
     
   }
  });
 
 